import 'babel-polyfill';
import 'core-js/es7/array';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import { I18nextProvider } from 'react-i18next';
import i18n from './services/i18n';
import { getFEClientName } from './services/serviceAPIHelper';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './reducers';

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)));

const clientCss = getFEClientName().toLowerCase();
ReactDOM.render(
    <div>
        <link rel="stylesheet" type="text/css" href="assets/css/index_default.css" />
        <link rel="stylesheet" type="text/css" href={'assets/' + clientCss + '/index.css'} />
        <Provider store={store}>
            <I18nextProvider i18n={i18n}>
                <App />
            </I18nextProvider>
        </Provider>
    </div>,
    document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js